var chunkMapping = {
	"0": [
		4650
	],
	"3": [
		4055,
		4584
	],
	"78": [
		5084
	],
	"163": [
		5171
	],
	"164": [
		5172
	],
	"167": [
		5175
	],
	"168": [
		5176
	],
	"169": [
		5177
	],
	"170": [
		5178
	],
	"171": [
		5179
	],
	"172": [
		5180
	],
	"173": [
		5181
	],
	"174": [
		5182
	],
	"175": [
		5183
	],
	"176": [
		5184
	],
	"177": [
		5185
	],
	"178": [
		5186
	],
	"179": [
		5187
	],
	"180": [
		5188
	],
	"181": [
		5189
	],
	"182": [
		5190
	],
	"183": [
		5191
	],
	"184": [
		5192
	],
	"185": [
		5193
	],
	"186": [
		5194
	]
};
var idToExternalAndNameMapping = {
	"4055": [
		"default",
		"./nuorder-components",
		3672
	],
	"4584": [
		"default",
		"./helios-components",
		3672
	],
	"4650": [
		"default",
		"./Containers",
		3582
	],
	"5084": [
		"default",
		"./OrderlessInvoices",
		3582
	],
	"5171": [
		"default",
		"./AsyncEventTracker",
		3582
	],
	"5172": [
		"default",
		"./HostWrapper",
		3582
	],
	"5175": [
		"default",
		"./CheckoutV3",
		3582
	],
	"5176": [
		"default",
		"./CheckoutConfirmation",
		3582
	],
	"5177": [
		"default",
		"./ContactCreditCards",
		3582
	],
	"5178": [
		"default",
		"./AuditDialog",
		3582
	],
	"5179": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3582
	],
	"5180": [
		"default",
		"./InvoiceDialog",
		3582
	],
	"5181": [
		"default",
		"./PaymentDueModal",
		3582
	],
	"5182": [
		"default",
		"./PaymentModal",
		3582
	],
	"5183": [
		"default",
		"./PaymentHistory",
		3582
	],
	"5184": [
		"default",
		"./PaymentConfigurations",
		3582
	],
	"5185": [
		"default",
		"./PaymentPreferences",
		3582
	],
	"5186": [
		"default",
		"./ManagePaymentProcessing",
		3582
	],
	"5187": [
		"default",
		"./MobilePaymentsWrapper",
		3582
	],
	"5188": [
		"default",
		"./PayPage",
		3582
	],
	"5189": [
		"default",
		"./Challenge",
		3582
	],
	"5190": [
		"default",
		"./ManagePaymentMethods",
		3582
	],
	"5191": [
		"default",
		"./LightspeedReports",
		3582
	],
	"5192": [
		"default",
		"./ActivateLightspeedPayments",
		3582
	],
	"5193": [
		"default",
		"./MarketingLandingPage",
		3582
	],
	"5194": [
		"default",
		"./ShippingPromotionsListContainer",
		3582
	]
};
var idToRemoteMap = {
	"4055": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3672
		}
	],
	"4584": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3672
		}
	],
	"4650": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5084": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5171": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5172": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5175": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5176": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5177": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5178": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5179": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5180": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5181": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5182": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5183": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5184": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5185": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5186": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5187": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5188": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5189": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5190": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5191": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5192": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5193": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5194": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}